<template>
	<div class="wh">
		<div class="wh" ref="elememt" id="table" ><!-- style="height:calc(100% - 44px);overflow-y: scroll" -->
			<el-table ref="multipleTable" @select-all="cfselect" :reserve-selection="true" :data="tableDatas" tooltip-effect  :header-cell-style="cellStyle" style="width: 100%" :max-height="tableHeight" v-loading="loading"  @select="selectOne">
				<el-table-column width="27" v-if="tableConfig.ischeck"></el-table-column>
				<el-table-column width="55" type="selection" v-if="tableConfig.ischeck"></el-table-column>
				<el-table-column width="33" v-if="!tableConfig.ischeck"></el-table-column>
				<el-table-column v-for="(item,index) in tableConfig.list" :key="index" :label="item.lable" :width="item.width">
					<template slot-scope="scope"  >
						<el-radio v-if="item.type == 'radio'" v-model="radio" :label="scope.row[item.prop]">{{ "" }}</el-radio>
						<img v-if="item.type == 'imgtou'" style="max-width: 80px; max-height: 80px;border-radius: 50%;margin: auto;"  :src="scope.row[item.prop]" alt="" @click="getimgulr(scope.row[item.prop])">
						<div v-else-if="item.type == 'imgs'" class="tbimgs">
							<img   v-for="el in climgs(scope.row[item.prop])" style="max-width: 80px;max-height: 80px;" :src="el" @click="getimgulr(el)">
							
						</div>
						<span v-else-if="item.type == 'img'" class="tbimgs" >
							<img v-for="el in clnIMG(scope.row[item.prop])" style="max-width: 80px;max-height: 80px;" :src="el" alt="" @click="getimgulr(el)">
						</span>
						
						
						<div v-else-if="item.type == 'url'" style="color: #FF5121;cursor: pointer;" @click="openwindowrouter(item.url,scope.row[item.id])">{{ scope.row[item.prop] }}</div>
						<div v-else-if="item.type == 'url1'" style="color: #FF5121;" @click="openwindow(item.url,scope.row[item.id])">{{ scope.row[item.prop] }}</div>
						<div v-else-if="item.type == 'urlopen'" style="color: #FF5121;" @click="openwindow(item.prop+scope.row['work_id'])">{{ item.prop+scope.row["work_id"] }}</div>
						
						<div v-else-if="item.type == 'clFnd'">
							<button style="width: 100px;" 
							:class="'fleft defaultbtn0'">
							{{item.clFnd(scope.row)}}
							</button>
							<span style="margin-left:5px;height: 100%;line-height: 2.5;">{{ scope.row['role'] }}</span>

						</div>
						<div v-else-if="item.type == 'btn'">
							<div v-if="item.child[scope.row[item.prop]] == '待审核' && scope.row.check_steps == '0'">
								<!-- <div v-if="adminuseraccess.indexOf('200573') > 0"> -->
									<button style="width: 100px;" :class="'fleft defaultbtn0 defaultbtn'+scope.row[item.prop]">1/2{{ item.child[scope.row[item.prop]] }}</button><span style="margin-left:5px;height: 100%;line-height: 2.5;">{{ scope.row['role'] }}</span>
								<!-- </div> -->
								
							</div>
							<div v-else-if="item.child[scope.row[item.prop]] == '待审核' && scope.row.check_steps == '1'">
								<!-- <div v-if="adminuseraccess.indexOf('200575') > 0"> -->
									<button style="width: 100px;" :class="'fleft defaultbtn0 defaultbtn'+scope.row[item.prop]">2/2{{ item.child[scope.row[item.prop]] }}</button><span style="margin-left:5px;height: 100%;line-height: 2.5;">{{ scope.row['role'] }}</span>
								<!-- </div> -->
							</div>
							<div v-else>
								<button style="width: 100px;" :class="'fleft defaultbtn0 defaultbtn'+scope.row[item.prop]">{{ item.child[scope.row[item.prop]] }}</button><span style="margin-left:5px;height: 100%;line-height: 2.5;">{{ scope.row['role'] }}</span>
							</div>
						</div>
						<span v-else-if="item.type == 'urlfile'">
							<span v-if="scope.row[item.filetype.name] == item.filetype.id">
								{{namChck(scope.row,item.prop.prop1)}}
							</span>
							<span v-else>
								<span class="routerLink pointer" @click="openwindow1(scope.row[item.prop.prop2])">{{ scope.row[item.prop.prop2] }}</span>
							</span>
						</span>
						<div v-else-if="item.type == 'merge'">
							<span v-if="item.is_hidden && scope.row[item.is_hidden.name] == item.is_hidden.value">
								{{ "--" }}
							</span>
							<span v-else>
								<span>{{ scope.row[item.child.id1] }}</span> 至 <span>{{ scope.row[item.child.id2]}}</span>
							</span>
							<!-- <span v-else-if="!item.is_success">{{ scope.row[item.child.id1] }}</span> 至 <span>{{ scope.row[item.child.id2]}}</span> -->
						</div>
						<div v-else-if="item.type == 'statustwo'">
							<span v-if="scope.row['is_del'] == '0'">
								<span :class="'status'+scope.row['status']">●</span><span>{{ item.child.status[scope.row['status']] }}</span>
							</span>
							<span v-else-if="scope.row['is_del'] != '0'">
								<span class="status-1">●</span><span>{{ item.child.is_del[scope.row['is_del']] }}</span>
							</span>
							<!-- <span>{{ scope.row['is_del'] }}</span> -->
						</div>
						<span v-else-if="item.type == 'keyvalue'"><span>{{ item.child[scope.row[item.prop]] ? item.child[scope.row[item.prop]] : item.child.no }}</span></span>
						<span v-else-if="item.type == 'novalue'"><span>{{ scope.row[item.prop] != "" ? scope.row[item.prop] : item.novalue }}</span></span>
						<span v-else-if="item.type == 'status'"><span :class="item.statusclass+scope.row[item.prop]">●</span><span>{{ item.child[scope.row[item.prop]] }}</span></span>
						<span v-else-if="item.type == 'nocon'">{{ scope.row[item.prop] ? scope.row[item.prop] : item.name }}</span>
						<span v-else-if="item.type == 'price'">{{ "￥" + formatMoney(scope.row[item.prop])  }}</span>
						<span v-else-if="item.type == 'baifen'">{{scope.row[item.prop] + "%" }}</span>
						<div v-else-if="item.type == 'hiretime'">
							<div style="color: #FF5121;" @click="openwindowrouter(item.url,scope.row[item.id])">
								{{ scope.row[item.prop] ? scope.row[item.prop] : "--" }}
							</div>
							<div>
								{{ scope.row[item.time] }} 
							 </div>
						</div>
						<div v-else-if="item.type == 'hiretime1'">
							<div>
								{{ scope.row[item.prop] ? scope.row[item.prop] : "--" }}
							</div>
							<div>
								{{ scope.row[item.time] }} 
							 </div>
						</div>
						<span v-else-if="item.type == 'address'">
							<span>{{
								scope.row[item.child[0]]+scope.row[item.child[1]]+scope.row[item.child[2]]
							}}</span>
						</span>
						<span v-else-if="!item.type">
						    <span>
								<span v-if="item.is_hidden && scope.row[item.is_hidden.name] == item.is_hidden.value">
									{{ item.is_hidden.namevalue }}
								</span>
								<span v-else>
									{{ scope.row[item.prop] }}
								</span>
						    </span>
						</span>
					</template>	
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="150" v-if="!tableAction.is_hidden">
					<template slot-scope="scope">
						
						
							<div v-if="tableAction.newBtn">
								<span v-for="el in tableAction.newBtn">
									<span @click="clickFn(el.clickFn,scope.row)"  v-if="checkascc(el.accessid) && (!el.checkFn || el.checkFn(scope.row))">
										<el-button 
											v-if="el.type=='btn'" 
											type="text" size="small">{{el.name}}</el-button>	
											<span v-else 
												class="pointer" style="padding: 0 10px;color:#33B3FF;font-size: 14px;" 
											>{{el.name}}</span>						
											</span>											
									</span>
							</div>
							
						
						
							<div v-if="!tableAction.pagefilterField">
								<span @click="handleClick(scope.row,'',tableAction.morebtns.page,$event)" class="pointer" style="padding: 0 10px;color:#33B3FF;font-size: 14px;" v-if="tableAction.links && tableAction.links.Ishow && tableAction.links.accessid && (adminuseraccess.indexOf(tableAction.links.accessid) > -1)">{{ tableAction.links.child ? tableAction.links.child[scope.row["status"]]:tableAction.links.name }}</span>
								<span @click="handleClick(scope.row,'',tableAction.morebtns.page,$event)" class="pointer" style="padding: 0 10px;color:#33B3FF;font-size: 14px;" v-if="tableAction.links && tableAction.links.Ishow && !tableAction.links.accessid">{{ tableAction.links.child ? tableAction.links.child[scope.row["status"]]:tableAction.links.name }}</span>
								
								<el-button @click="handleClick(scope.row,'contributor',tableAction.morebtns.page)" type="text" size="small" v-if="tableAction.morebtns && tableAction.morebtns.Ishow && !tableAction.morebtns.child && tableAction.morebtns.accessid && (adminuseraccess.indexOf(tableAction.morebtns.accessid) > -1)">{{ tableAction.morebtns.name }}</el-button>
								<el-button @click="handleClick(scope.row,'contributor',tableAction.morebtns.page)" type="text" size="small" v-if="tableAction.morebtns && tableAction.morebtns.Ishow && !tableAction.morebtns.child && !tableAction.morebtns.accessid">{{ tableAction.morebtns.name }}</el-button>
								
								<el-dropdown trigger="hover" v-if="tableAction.morebtns && tableAction.morebtns.Ishow && tableAction.morebtns.child ">
									<span class="el-dropdown-link" style="padding:0 21px;">{{ tableAction.morebtns.name }}</span>
									<el-dropdown-menu class="sel-tooltip" slot="dropdown">
										<el-dropdown-item v-if="citem.accessid && (adminuseraccess.indexOf(citem.accessid) > -1)" v-for="(citem,index) in tableAction.morebtns.child" :key="index" class="comonbtn" @click.native="handleClick(scope.row,'contributor'+ index,tableAction.morebtns.page)">{{ citem.name }}</el-dropdown-item>
										<el-dropdown-item v-if="!citem.accessid" v-for="(citem,index) in tableAction.morebtns.child" :key="index" class="comonbtn" @click.native="handleClick(scope.row,'contributor'+ index,tableAction.morebtns.page)">{{ citem.name }}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
							<div  v-else-if="tableAction.pagefilterField">
								<el-button style="padding: 0 10px;" @click="handleClick(scope.row,'',tableAction.morebtns.page)" type="text" size="small" v-if="tableAction.links.Ishow  && ( tableAction.links.filterField ? (tableAction.links.filterField.indexOf(scope.row[tableAction.pagefilterFieldid]) > -1) : true ) && tableAction.links.accessid && (adminuseraccess.indexOf(tableAction.links.accessid) > -1)">{{ tableAction.links.name }}</el-button>
								<el-button style="padding: 0 10px;" @click="handleClick(scope.row,'',tableAction.morebtns.page)" type="text" size="small" v-if="tableAction.links.Ishow  && ( tableAction.links.filterField ? (tableAction.links.filterField.indexOf(scope.row[tableAction.pagefilterFieldid]) > -1) : true ) && !tableAction.links.accessid">{{ tableAction.links.name }}</el-button>
								<el-button style="padding: 0 10px;" @click="handleClick(scope.row,'activitydetel')" type="text" size="small" v-if="scope.row['status'] == '-1'">{{ tableAction.delete.name }}</el-button>
								
								<el-button @click="handleClick(scope.row,'contributor',tableAction.morebtns.page)" type="text" size="small" v-if="tableAction.morebtns.Ishow && !tableAction.morebtns.child && tableAction.morebtns.accessid && (adminuseraccess.indexOf(tableAction.morebtns.accessid) > -1)">{{ tableAction.morebtns.name }}</el-button>
								<el-button @click="handleClick(scope.row,'contributor',tableAction.morebtns.page)" type="text" size="small" v-if="tableAction.morebtns.Ishow && !tableAction.morebtns.child && !tableAction.morebtns.accessid">{{ tableAction.morebtns.name }}</el-button>
								
								<el-dropdown trigger="hover" v-if="tableAction.morebtns.Ishow && tableAction.morebtns.child && (tableAction.morebtns.filterField.indexOf(scope.row[tableAction.pagefilterFieldid]) > -1)">
									<span class="el-dropdown-link" style="padding:0 21px;">{{ tableAction.morebtns.name }}</span>
									<el-dropdown-menu class="sel-tooltip" slot="dropdown">
										<el-dropdown-item v-for="(citem,index) in tableAction.morebtns.child" v-if="!citem.accessid && (citem.filterField.indexOf(scope.row[tableAction.pagefilterFieldid]) > -1)" :key="index" class="comonbtn" @click.native="handleClick(scope.row,citem.id,tableAction.morebtns.page)">{{ citem.name }}</el-dropdown-item>
										<el-dropdown-item v-for="(citem,index) in tableAction.morebtns.child" v-if="citem.accessid && (adminuseraccess.indexOf(citem.accessid) > -1) && (citem.filterField.indexOf(scope.row[tableAction.pagefilterFieldid]) > -1)" :key="index" class="comonbtn" @click.native="handleClick(scope.row,citem.id,tableAction.morebtns.page)">{{ citem.name }}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="w" style="text-align: right;background: #FFFFFF;">
				<div class="fleft" style="color: #999999;margin-left: 40px;">
					<span>已选择{{ multipleSelectionMy.length }}条,</span><span>共{{Number(total)}}条数据</span><button style="width:87px;height: 32px;" class="defaultbtn" @click="setall">{{btnStatus?'选择全部':'取消全选'}}</button>
				</div>
				<el-pagination v-if="total" class="sel-pagin" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				 :page-sizes="[50, 100, 200, 500,1000,2000]" :page-size="limit" layout="prev, pager, next, sizes,jumper" :total="total">
				</el-pagination>
			</div>
			<div class="w textcenter">
				<button class="defaultbtn defaultbtnactive" @click="setchange()">确定({{ multipleSelectionMy.length }})</button>
			</div>
		</div>
		<div class="maskimg screenContent" v-if="isimgurl" @click="getimgulr">
			<img :src="imgurl" alt="暂无图片" style="max-height: 500px;">
		</div>
	</div>
</template>
<!-- :total="tableConfig.total" -->
<script>
	export default {
		props: ['tableConfig','tableAction','config'],
		data() {
			return {
				IsMoreShow: false,
				tableHeight: 150,
				currentpage: 1,
				pagesize: 50,
				selected:0,
				loading:true,
				allselect:false,
				sel:true,
				multipleSelectionAll:[],
				multipleSelection:[],
				pageid:"",
				imgurl:"",
				isimgurl:false,
				adminuseraccess: [],
				radio:'',
				row:{},
				btnStatus: true,
				page:1,
				limit:50,
				total:0,
				allTable:[],
				tableDatas:[],
				multipleSelectionMy:[],
				seallt:false
			}
		},
		methods: {
			setchange(){
				this.$emit('seletFn',this.multipleSelectionMy);
			},
			selectOne(selection,row){
				let id = row[this.config.prop];
				let on = this.multipleSelectionMy.indexOf(id);
				
				if(on==-1){
					this.multipleSelectionMy.push(id)	
					this.$refs.multipleTable.toggleRowSelection(row, true)
					return
				}
				this.multipleSelectionMy.splice(on,1);						
				this.$refs.multipleTable.toggleRowSelection(row, false)
			},
			cfselect(){
				if(this.seallt){
					this.seallt=false;
					return
				}
				this.setall();
			},
			getTableData(){
				let pr = {
					access_token: localStorage.getItem("access_token"),
					page: this.page,
					// limit: this.total?this.total:50,
					limit:this.limit||50
				}

				if (this.$route.query.urlDate) {
					const sreenData = JSON.parse(this.$route.query.urlDate);
					
					pr = Object.assign(pr,sreenData);
				}		
				this.loading = true						
				this.api[this.config.ajax.url](pr).then((da)=>{
					this.allTable = da.data;
					this.tableDatas = da.data
					if(this.total==0){
						this.total = da.total;
						this.getTableData();
						return
					}
					this.total = da.total;
					this.loading = false
					// this.setTableData();									
				}).catch((err)=>{
					console.log(err)
					this.loading = false
				})
	
				
			},
			setTableData(){
				
				let str = this.page*this.limit-this.limit;
				let end = str+this.limit;
				this.tableDatas = this.allTable.slice(str,end);	
				setTimeout(()=>{
					this.tableDatas.map((el,index)=>{
						if(this.multipleSelectionMy.indexOf(el[this.config.prop])!=-1){
							this.$refs.multipleTable.toggleRowSelection(this.tableDatas[index], true)
						}
					})		
				},50)
			},
			clickFn(fn,row){
				this.$emit('clickFn',{fn:fn,pr:row})
			},
			checkascc(id){
				return  !id || this.adminuseraccess.indexOf(id)>-1;
			},
			clnIMG(UM){
				let st = [];
				try{
					st = JSON.parse(UM);
				}catch(e){
					st = [UM];
				}
				st = st.map(url => `${url}?x-oss-process=image/resize,m_lfit,h_120,w_120`)
				return st
			},
			climgs(all){
				if(!all){
					return []
				}
				all = all.map(url => `${url}?x-oss-process=image/resize,m_lfit,h_120,w_120`)
				return all.slice(0,3)
			},
			namChck: function (n,k) {
				if(n.business_type==5){
					return n[k]+'.mp4';
				}
				
			  return  n[k];
			},
			
			formatMoney(input){ 
                var n = parseFloat(input).toFixed(2);
                var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
                return n.replace(re, "$1,");
            },
			setparenttable(){
				if(!this.tableAction.morebtns){
					return
				}
				switch(this.tableAction.morebtns.page){
					case "userBaseInfo":
						
					break;
					case "workInfo":
						
					break;
					case "worksShelves":
						
					break;
					case "newActivity":
						this.$parent.$parent.getactivitiesrows(this.row);
						this.$parent.$parent.dialogTableVisible = false;
					break;
					case "newproject":
					case "newprojectLong":
					    this.$parent.$parent.getactivitiesrows1(this.row);
					    this.$parent.$parent.dialogTableVisible2 = false;
					break;
					case "addblack":
						
					break;
				}
			},
			rowclick(row){
				this.row = row;
				this.radio = row[this.tableConfig.selectid];
			},
			handleClick(row, setid, page,event) {
				if(setid == "activitydetel"){		
					this.$parent.delect(row);
				}
				//return;
				
				switch(page){
					
					case "userBaseInfo":
						if (setid == "contributor0") {
							this.$parent.setContributor(row);
						}
						
						if (setid == "contributor1") {
							//alert(1)
							let a = [];
							a.push(row)
							this.router.push({path:"/userManager/blackList/addblack",query:{rows:JSON.stringify(a)}});
							//this.$parent.setContributor(row);
						}
						if (!setid) {
							this.router.push({path:"/userManager/userBaseInfo/userBaseInfoDetail",query:{open_id:row.open_id}});
							///this.$parent.linkDetail(row.open_id);
						}
					break;
					case "userCompanyInfo":
						if (!setid) {
							this.router.push({path:"/userManager/userCompanyInfo/userCompanyInfoDetail",query:{open_id:row.open_id}});
							///this.$parent.linkDetail(row.open_id);
						}
					break;
					case "userPersonalInfo":
						if (!setid) {
							this.router.push({path:"/userManager/userPersonalInfo/userPersonalInfoDetail",query:{open_id:row.open_id}});
							///this.$parent.linkDetail(row.open_id);
						}
					break;
					case "roleManager":
						if (setid == "contributor0") {
							this.router.push({path:"/power/roleManager/editRoles",query:{id:row.id,name:row.name,description:row.description}});
						}
						if (setid == "contributor1") {
							this.$parent.delect(row.id);
							//this.router.push({path:"/power/roleManager/editRoles",query:{id:row.id}});
						}
						if(!setid){
							this.router.push({path:"/power/roleManager/seeRoles",query:{id:row.id}});
						}
					break;
					case "accountManager":
						if (setid == "contributor") {
							this.router.push({path:"/power/accountManager/setRoles",query:{row:JSON.stringify(row)}});
						}
						if(!setid){
							this.router.push({path:"/power/accountManager/seeaccount",query:{row:JSON.stringify(row)}});
						}
					break;
					case "publishWork":
						if(!setid){
							this.router.push({path:"/review/publishWork/workDetial",query:{id:row.id,type:1,check_status:row.check_status,work_id:row.work_id}});
							
						}
					break;
					case "projectreview":
						if(!setid){
							this.router.push({path:"/review/projectreview/projectdetial",query:{id:row.id,type:5,check_status:row.check_status,project_id:row.project_id,business_type:row.business_type}});
							
						}
					break;
					case "projectreviewbm":
						if(!setid){
							this.router.push({path:"/review/projectreview/xxbmxq",query:{signup_id:row.signup_id,id:row.id,type:6,check_status:row.check_status,project_id:row.project_id,business_type:row.business_type}});
							
						}
					break;
					case "projectreviewxb":
						if(!setid){
							this.router.push({path:"/review/projectreview/xxxbxq",query:{signup_id:row.signup_id,id:row.id,type:7,check_status:row.check_status,project_id:row.project_id,business_type:row.business_type}});
							
						}
					break;
					case "finalistsWork":
						if(!setid){
							this.router.push({path:"/review/finalistsWork/workDetial",query:{id:row.id,type:2,check_status:row.check_status,work_id:row.work_id}});
							
						}
					break;
					case "employWork":
						if(!setid){
							this.router.push({path:"/review/employWork/workDetial",query:{id:row.id,type:3,check_status:row.check_status,work_id:row.work_id}});
							
						}
					break;
					case "applyPerson":
					//console.log(row);
						if(!setid){
							this.router.push({path:"/review/applyPerson/workDetial",query:{id:row.id,type:4,check_status:row.check_status,contribute_type:row.contributor_type}});
						}
					break;
					case "workInfo":
						this.pageid = "work_id";
						if(!setid){
							this.router.push({path:"/workManager/workInfo/workInfoDetial",query:{id:row.work_id}});
							
						}
						if(setid == "contributor0"){
							//this.post(localStorage.getItem("baseURLs")+"/work/preview",{access_token:localStorage.getItem('access_token'),work_id:row.work_id},"newpage");
							//this.openPostWindow(localStorage.getItem("baseURLs")+"/work/preview",{access_token:localStorage.getItem('access_token'),work_id:row.work_id},"newpage");
							window.open( localStorage.getItem("baseURLs")+"/work/preview?work_id=" + row.work_id+"&access_token="+localStorage.getItem('access_token'));
						}
						
						if(setid == "contributor1"){
							this.router.push({path:"/workManager/workInfo/worksShelves",query:{id:row.work_id,open_id:row.open_id}});
						}
						if(setid == "contributor2"){
							this.$parent.centerDialogVisible2 = true;
							this.$parent.Isnextshow = false;
							this.$parent.workid = row.work_id;
							this.$parent.did='';
							this.$parent.price='';
						}
						if(setid == "contributor3"){
							this.$parent.setContributor(row);
							//this.router.push({path:"/workManager/workInfo/workEmploy",query:{id:row.work_id}});
						}
						if(setid == "contributor4"){
							this.$parent.centerDialogVisible3 = true;
							this.$parent.workid = row.work_id;
						}
					break;
					case "commentManager":
						if(!setid){
							//this.router.push({path:"/review/applyPerson/workDetial",query:{id:row.id,type:4,check_status:row.check_status}});
							
							this.$parent.delect(row);
						}
					break;
					case "activityClass":
						if(!setid){
							this.router.push({path:"/activityManager/activityClass/editActivity",query:{id:row.id,num:row.processing_activity_num,name:row.category_name,status:row.status}});
						}
					break;
					case "activityworks":
						if(!setid){
							window.open( localStorage.getItem("baseURLs")+"/work/preview?work_id=" + row.work_id+"&access_token="+localStorage.getItem('access_token'));
						}
					break;
					case "activityEmploy":
						if(!setid){
							window.open(localStorage.getItem("URL")+"/#/detailed?id=" + row.id);
						}

						if(setid == "top0"){
							this.$parent.delect(row);
							///this.router.push({path:"/activityManager/activityClass/editActivity",query:{id:row.id,num:222}});
						}
						
						if(setid == "top1"){
							this.router.push({path:"/activityManager/activityEmploy/editActivity",query:{row:JSON.stringify(row)}});
						}
					break;
					case "solicitationTemplate":
						
					
						if(setid == "contributor0"){
							this.$parent.centerDialogVisible = true;
							this.$parent.rowdata = row;
							///this.router.push({path:"/activityManager/activityClass/editActivity",query:{id:row.id,num:222}});
						}
						if(setid == "contributor2"){
							//console.log(row.template_url);
							/* if(row.file_type == "video"){
								fetch(row.template_url).then(res => res.blob()).then(blob => {
									const a = document.createElement('a');
									document.body.appendChild(a)
									a.style.display = 'none'
									// 使用获取到的blob对象创建的url
									const url = window.URL.createObjectURL(blob);
									a.href = url;
									// 指定下载的文件名
									a.download = row.file_name;
									a.click();
									document.body.removeChild(a)
									// 移除blob对象的url
									window.URL.revokeObjectURL(url);
								}); 
								
							}
							
							if(row.file_type == "zip"){
								window.open(row.template_url);
							} */
							
							fetch(row.template_url).then(res => res.blob()).then(blob => {
								const a = document.createElement('a');
								document.body.appendChild(a)
								a.style.display = 'none'
								// 使用获取到的blob对象创建的url
								const url = window.URL.createObjectURL(blob);
								a.href = url;
								// 指定下载的文件名
								a.download = row.file_name;
								a.click();
								document.body.removeChild(a)
								// 移除blob对象的url
								window.URL.revokeObjectURL(url);
							}); 
							
							
							//window.open(row.template_url);
						}
						if(setid == "contributor1"){
							this.$parent.delete(row);
							///this.router.push({path:"/activityManager/activityClass/editActivity",query:{id:row.id,num:222}});
						}
					break;
					case "homeBanner":
						if(setid == "contributor"){
							this.$parent.delect(row);
						}
						if(!setid){
							this.router.push({path:"/contentManager/homeBanner/editHomeBanner", query:{row: JSON.stringify(row)}})
							///this.router.push({path:"/activityManager/activityClass/editActivity",query:{id:row.id,num:222}});
						}
						
					break;
					case "hotWordSearch":
						if(!setid){
							this.router.push({path:"/contentManager/hotWordSearch/edithotword", query:{row: JSON.stringify(row)}})
						}
						
						if(setid == "contributor"){
							this.$parent.delect(row);
						}
					break;
					case "serviceCenter":
						if(!setid){
							if(row.type == '2'){
								window.open(localStorage.getItem("URL")+"/#/userProtocol");
							} else if(row.type == '1'){
								window.open(localStorage.getItem("URL")+"/#/about");
							}else if(row.type == '3'){
								window.open(localStorage.getItem("URL")+"/#/authorization");
							}else if(row.type == '4'){
								window.open(localStorage.getItem("URL")+"/#/help");
							}
							
						}
						if(setid == "contributor0"){
							this.router.push({path:"/contentManager/serviceCenter/editserviceCenter", query:{row: JSON.stringify(row)}})
						}
						
						if(setid == "contributor1"){
							this.$parent.delect(row);
						}
						
						if(setid == "contributor2"){
							this.$parent.edit(row);
						}
					break;
					case "recommendedActivities":
						if(!setid){
							this.router.push({path:"/contentManager/recommendedActivities/editrecommendedActivities", query:{row: JSON.stringify(row)}})
						}
						
						if(setid == "contributor"){
							this.$parent.delect(row);
						}
					break;
					case "blackList":
						if(!setid){
							this.router.push({path:"/userManager/blackList/editblack", query:{id: row.id,url:row.avatar}})
						}
					break;
					case "listAd":
						if(!setid){
							this.router.push({path:"/contentManager/editlistAd", query:{row: JSON.stringify(row)}})
						}
						
						if(setid == "contributor"){
							this.$parent.delect(row);
						}
					break;
					case "newrecommendedActivities":
						if(!setid){
							this.$parent.$parent.getactivitiesrows(row);
							this.$parent.$parent.dialogTableVisible = false;
						}
					break;
					/* case "newlistAd":
						if(!setid){
							this.$parent.$parent.getactivitiesrows(row);
							this.$parent.$parent.dialogTableVisible = false;
						}
					break; */
					case "employmentorder":
						if(!setid){
							this.router.push({path:"/employmentManager/employmentorder/orderDetial", query:{id: row.order_id,check_admin_name:row.check_admin_name,hire_time:row.hire_time}})
						}
						if(setid == "contributor"){
							this.$parent.delect(row);
						}
					break;
					case "addbannerScheme":
						if(!setid){
							this.$parent.$parent.getactivitiesrows(row);
							this.$parent.$parent.dialogTableVisible = false;
						}
					break;
					case "presetReason":
						if(!setid){
							if(event.target.innerHTML == "启用"){
								this.$confirm('确认'+ event.target.innerHTML +'该驳回理由', '确认修改', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									dangerouslyUseHTMLString: true,
									type: '',
									center: true
								}).then(() => {
									this.$parent.update(row,1,"启用");
									event.target.innerHTML = "停用"
								}).catch(() => {
									this.$message({
										type: 'info',
										message: '已经取消'
									});
								});
								
								
							} else{
								this.$confirm('确认'+ event.target.innerHTML +'该驳回理由', '确认修改', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									dangerouslyUseHTMLString: true,
									type: '',
									center: true
								}).then(() => {
									this.$parent.update(row,0,"停用");
									event.target.innerHTML = "启用"
								}).catch(() => {
									this.$message({
										type: 'info',
										message: '已经取消'
									});
								});
								
								
							}
						}
						if(setid == "contributor"){
							this.$confirm('确认删除该驳回理由', '确认修改', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								dangerouslyUseHTMLString: true,
								type: '',
								center: true
							}).then(() => {
								this.$parent.update(row,-1,"删除");
							}).catch(() => {
								this.$message({
									type: 'info',
									message: '已经取消'
								});
							});
						}
					break;
					case "feedback":
						if(!setid){
							if(this.$parent.tabsnum == 0){
								this.router.push({path:"/otherInformation/feedback/seefeedback", query:{feedback_id:row.feedback_id}})
							} else {
								if(event.target.innerHTML == "启用"){
									this.$confirm('确认'+ event.target.innerHTML +'该驳回理由', '确认修改', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										dangerouslyUseHTMLString: true,
										type: '',
										center: true
									}).then(() => {
										this.$parent.update(row,1,"启用");
										event.target.innerHTML = "停用"
									}).catch(() => {
										this.$message({
											type: 'info',
											message: '已经取消'
										});
									});
								} else{
									this.$confirm('确认'+ event.target.innerHTML +'该驳回理由', '确认修改', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										dangerouslyUseHTMLString: true,
										type: '',
										center: true
									}).then(() => {
										this.$parent.update(row,0,"停用");
										event.target.innerHTML = "启用"
									}).catch(() => {
										this.$message({
											type: 'info',
											message: '已经取消'
										});
									});
								}
							}
							
							
						}
						if(setid == "contributor"){
							
							this.$confirm('确认删除该驳回理由', '确认修改', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								dangerouslyUseHTMLString: true,
								type: '',
								center: true
							}).then(() => {
								this.$parent.update(row,-1,"删除");
							}).catch(() => {
								this.$message({
									type: 'info',
									message: '已经取消'
								});
							});
							
							
						}
					break;
					case "reportInfo":
						if(!setid){
							if(this.$parent.tabsnum == 0){
								this.router.push({path:"/otherInformation/reportInfo/seereportInfo", query:{report_id:row.report_id}})
							} else {
								if(event.target.innerHTML == "启用"){
									this.$confirm('确认'+ event.target.innerHTML +'该驳回理由', '确认修改', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										dangerouslyUseHTMLString: true,
										type: '',
										center: true
									}).then(() => {
										this.$parent.update(row,1,"启用");
										event.target.innerHTML = "停用"
									}).catch(() => {
										this.$message({
											type: 'info',
											message: '已经取消'
										});
									});
								} else{
									this.$confirm('确认'+ event.target.innerHTML +'该驳回理由', '确认修改', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										dangerouslyUseHTMLString: true,
										type: '',
										center: true
									}).then(() => {
										this.$parent.update(row,0,"停用");
										event.target.innerHTML = "启用"
									}).catch(() => {
										this.$message({
											type: 'info',
											message: '已经取消'
										});
									});
								}
							}
							
							
						}
						if(setid == "contributor"){
							
							this.$confirm('确认删除该驳回理由', '确认修改', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								dangerouslyUseHTMLString: true,
								type: '',
								center: true
							}).then(() => {
								this.$parent.update(row,-1,"删除");
							}).catch(() => {
								this.$message({
									type: 'info',
									message: '已经取消'
								});
							});
							
							
						}
					break;
					case "newsRelease":
						if(!setid){
							this.router.push({path:"/noticeManager/newsRelease/editrelease", query:{row: JSON.stringify(row)}})
						}
						
						if(setid == "contributor"){
							this.$parent.delect(row);
						}
					break;
					case "embodyRecord":
						if(!setid){
							this.router.push({path:"/otherInformation/embodyRecord/seeembodyRecord", query:{row: JSON.stringify(row)}})
						}
					break;
					case "newActivity":
						if(!setid){
						   this.$parent.$parent.getactivitiesrows(row);
						   this.$parent.$parent.dialogTableVisible = false;
						}
					break;
					case "newprojectrecommende":
						if(!setid){
						   this.$parent.$parent.getactivitiesrows(row);
						   this.$parent.$parent.dialogTableVisible = false;
						}
					break;
					case "newproject":
						if(!setid){
						   this.$parent.$parent.getactivitiesrows1(row);
						   this.$parent.$parent.dialogTableVisible2 = false;
						}
					break;
				}
			},
			handleSizeChange(val) {
				this.limit  = val;
				this.setTableData();
				this.$nextTick(() => {
					this.$refs.elememt.scrollTo(0,'34px');
				})
			},
			handleCurrentChange(val) {
				this.page= val;
				// this.setTableData();
				this.getTableData()
				this.$nextTick(() => {
					this.$refs.elememt.scrollTo(0,'34px');
				})
			},
			handleSelectionChange(val) {
				// console.log(val.length)
				this.selected = val.length;
				if(val.length == '0'){
					this.btnStatus = true;
				}else{
					this.btnStatus = false;
				}
				this.multipleSelectionAll=[];
				if(this.tableConfig.masktable){
					
				} else {
					if(this.sel == false){
						return;
					}
					this.multipleSelection = val
					this.changePageCoreRecordData(this.multipleSelection)
					
					
				}
				
				
			},
			changePageCoreRecordData (x) {
                // 总选择里面的key集合
				let selectAllIds = [];
				
				this.multipleSelectionAll.forEach((row,index)=>{
					selectAllIds.push(row[this.pageid]);	
				})
				// console.log(selectAllIds)
				
				let selectIds = [];
				// 获取当前页选中的id
				//console.log(this.pageid);
				x.forEach((row,index)=>{
					selectIds.push(row[this.pageid]);
					if (selectAllIds.indexOf(row[this.pageid]) < 0) {
						this.multipleSelectionAll.push(row);
						// console.log(this.multipleSelectionAll)
					}
				});
				
				let pageids = [];
				let noSelectIds = [];
				this.tableDatas.forEach((row,index)=>{
				    pageids.push(row[this.pageid]);
					if (selectIds.indexOf(row[this.pageid]) < 0) {
					    noSelectIds.push(row[this.pageid]);
					}
				})
				noSelectIds.forEach(id=>{
				    if (selectAllIds.indexOf(id) >= 0) {
				        for(let i = 0; i< this.multipleSelectionAll.length; i ++) {
				            if (this.multipleSelectionAll[i][this.pageid] == id) {
				                // 如果总选择中有未被选中的，那么就删除这条
				                this.multipleSelectionAll.splice(i, 1);
				            }
				        }
				    }
				})
                // console.log(this.multipleSelectionAll);
				if( this.$parent.$parent.pageName && this.$parent.$parent.pageName == "addblack"){
					
					if(this.$parent.$parent.tabnum == 0) {
						this.$parent.$parent.selectData = this.multipleSelectionAll;
					} else {
						let ids = [];
						if(this.multipleSelectionAll.length > 1){
							this.multipleSelectionAll.forEach((item,index)=>{
								this.multipleSelectionAll.forEach(items=>{
									if(item.open_id == items.open_id){
										this.multipleSelectionAll.splice(index,1);
									}
								})
							})
						}
						
						//console.log(this.multipleSelectionAll)
						this.$parent.$parent.selectData1 = this.multipleSelectionAll;
						//console.log(this.$parent.$parent.selectData1)
					}
					return;
				}
				
				this.selected = this.multipleSelectionAll.length;
				
				if(this.$parent.selectData){
					this.$parent.selectData = this.multipleSelectionAll;
				}
				if(this.$parent.$parent.selectData){
					this.$parent.$parent.selectData = this.multipleSelectionAll;
				}
				
				
				
			},
			change(data){
				let _this = this
                for(let i = 0;i<data.length;i++){
					var c = i
                    for(let x = 0;x<this.multipleSelectionAll.length;x++){     
						if(data[i][this.pageid] == this.multipleSelectionAll[x][this.pageid] ){
							var f = function(a){
								setTimeout(() => {
									_this.$refs.multipleTable.toggleRowSelection(data[a],true);
								}, 100);
							}
							f(c)
							
							//_this.$refs.multipleTable.toggleRowSelection(data[i],true);
						}
					}
                }
                
            },
			getTabData() {
				const data = {
					pageCurrent: this.currentpage,
					pageSize: this.pagesize
				};
				
				if(this.$parent.getData){
					this.$parent.getData(data);
				}
				if(this.$parent.$parent.getData){
					this.$parent.$parent.getData(data);
				}
			},
			autoTableHeight() {
				//设置table标签
				
				setTimeout(() => {
					this.tableHeight = this.$refs.elememt.offsetHeight / 100 * 88;
				}, 100)
				//此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
				//this.$refs.table.$el.offsetTop：表格距离浏览器的高度
			},
			init(){
				if(this.tableConfig.loading){
					// this.loading = false;
				}
			},
			cellStyle() {
			  return 'borderBottom: 5px solid #f0f2f5'
			},
			setLoding(type){
				// this.loading = type;
			},
			cheaxz(id){
				/* let on = this.ids.indexOf(id);
				if(on!=-1){
					this.ids.splice(on,1);
				}else{
					this.ids.push(id);
				}
				let pok = [];
				for(let i=0,n=this.ids.length;i<n;i++){
					pok.push({id:this.ids[i]});
				}
				this.multipleSelection = pok;
				this.$parent.xzFn(this.multipleSelection); */
				
			},	
			setall(){					
				this.sel = !this.sel;
				if(this.sel){
					let arr = [];
					this.allTable.map((el)=>{
						arr.push(el[this.config.prop])
					})						
					this.multipleSelectionMy = arr;
					this.seallt=true;
					this.btnStatus=false;
					this.$refs.multipleTable.toggleAllSelection();
					return
				}
				this.multipleSelectionMy = [];
				this.seallt=true;
				this.btnStatus=true;
				this.$refs.multipleTable.clearSelection();						
			},
			setSelett(data,type){
				data.forEach(row => {
				    if (row) {
				        this.$refs.multipleTable.toggleRowSelection(row, type)
				    }
				});
			},
			setinit(){
				this.sel = true;
				this.selected = 0;
				this.$parent.seltotal = 0;
				this.toggleSelection();
			},
			toggleSelection(rows) {
				if (rows) {
				  rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				  });
				} else {
				  this.$refs.multipleTable.clearSelection();
				}
			},
			getRowKeys(row) {
				return row.id;
			},
			getimgulr(url){
				this.imgurl = url;
				this.isimgurl = !this.isimgurl
			},
			openwindow(url,id){
				window.open(localStorage.getItem('URL')+url+id)
			},
			openwindowrouter(url,id){
				const {href} = this.$router.resolve({ path: url+id})
				window.open(href, '_blank')
			},
			openwindow1(url){
				window.open(url)
			},
			
		},
		mounted() {
			this.autoTableHeight();
			this.init();
			if(localStorage.getItem("adminuseraccess")){
				this.adminuseraccess = JSON.parse(localStorage.getItem("adminuseraccess"))
			}
		},
		created() {
			if(this.tableAction.morebtns){
				switch(this.tableAction.morebtns.page){
					case "userBaseInfo":
						this.pageid = "open_id";
					break;
					case "workInfo":
						this.pageid = "work_id";
					break;
					case "worksShelves":
						this.pageid = "open_id";
					break;
					case "newActivity":
						this.pageid = "template_file_id";
					break;
					case "addrelease":
						this.pageid = "open_id";
					break;
					case "addblack":
						if(this.$parent.$parent.tabnum == 0){
							this.pageid = "open_id";
						} else {
							this.pageid = "report_id";
						}
						
					break;
				}
			}
			this.multipleSelectionMy = this.config.propData;
			this.getTableData();
		},
		watch:{
			"$route":function(){
				this.getTableData();
			}
		}
	}
</script>
<style scoped="scoped">
	.status-2{
		color: #f72522;
	}
	.status-1{
		color: #f72522;
	}
	.status0{
		color:#fcae00;
	}
	.status1{
		color:#fcae00;
	}
	.status2{
		color:#4dc600;
	}
	.status10{
		color:#4dc600;
	}
	.status11{
		color:#4dc600;
	}
	
	.presetReasonstatus0{
		color:#f72522;
	}
	
	.presetReasonstatus1{
		color:#4dc600;
	}
	
	.newsReleasestatus0{
		color:#bfbfbf;
	}
	
	.newsReleasestatus1{
		color:#008dff;
	}
	
	.newsReleasestatus2{
		color:#4dc600;
	}
	
	.activityEmploystatus-1{
		color:#bfbfbf;
	}
	.activityEmploystatus0{
		color:#bfbfbf;
	}
	.activityEmploystatus1{
		color:#008dff;
	}
	
	.recommendedActivitiesstatus0{
		color:#bfbfbf;
	}
	.recommendedActivitiesstatus1{
		color:#008dff;
	}
	.recommendedActivitiesstatus-1{
		color:#f72522;
	}
	.recommendedActivitiesstatus-2{
		color:#f72522;
	}
	
	.maskimg{
		position: fixed;
		top:0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
		z-index: 2005;
	}
	.wh >>> .is-leaf{
		height: 60px;
		line-height: 60px;
		padding: 0;
	}
	.sel-tooltip{
		width: 170px;
		border: 1px solid #E6E6E6;
		position: absolute;	
		background: white;
		margin-top: 9px;
		box-shadow: 0 2px 8px 0 rgba(0,0,0,0.10);
		border-radius: 2px 2px 2px 2px;
	}
	.sel-tooltip .comonbtn:hover{
		color: #33B3FF !important;
        background: #e5f5ff !important;
	}
	.el-popper{
		position: absolute;
		top: 332px;
	}
	/* #table .el-table th.is-leaf {
		border-bottom: 5px solid #545C64;
	} */
	/* .el-table__fixed {
		margin-left: 27px;
	} */
	.tbimgs{
		width: 270px;
	}
	.tbimgs>img{
		margin: 0 10px 0 0;
		display: inline-block;
		vertical-align: top;
	}
	.newbtns_01>span{
		margin: 0 6px;
		cursor: pointer;
	}
</style>
